import { EditOutlined, SaveOutlined, MinusCircleOutlined, DeleteOutlined, ReadOutlined } from "@ant-design/icons";
import { Checkbox, Col, Form, Row, Input, Space } from "antd";
import ButtonComponent from "components/ButtonComponent";
import DrawerComponent from "components/DrawerComponent";
import TableComponent from "components/TableComponent";
import TableConfig from "components/TableConfig";
import BasicCrud from "components/crud/BasicCrud";
import FormComponent from "components/form/FormComponent";
import InputCheckbox from "components/form/InputCheckbox";
import InputSelect from "components/form/InputSelect";
import InputText from "components/form/InputText";
import InventoryForm from "components/form/InventoryForm";
import PopDelete from "components/popup/PopDelete";
import InputDate from "components/form/InputDate";
import useFormHook from "hooks/useFormHook";
import React, { useEffect, useRef, useState } from "react";
import { Operations } from "utils/constants";
import { OPTIONS } from "utils/dummy";
import { json } from "react-router-dom";
import { getDepartmentAccordingBranch, getTransactionDetail } from "utils/functions";
import { set } from "lodash";

export default function OpeningInventory() {
  const [recordId, setRecordId] = useState(null)

  const initialValues = {
    OperationId: 1,
    Id: null,
    ReferenceNo: null,
    TransactionTypeId: null,
    DemandOrderId: null,
    TransactionDate: null,
    TransactionNo: "",
    SupplierId: null,
    DepartmentId: null,
    ToDepartmentId: null,
    BranchId: null,
    UserId: 1,
    Gross: 0,
    Tax: 0,
    Discount: 0,
    Amount: 0,
    TimeStamp: "",
    Enabled: 1,
    Deleted: 0,
    IsSubmit: false,
    TransType: "OPENING_INVENTORY",
    TransactionDetail: [
      {
        ItemId: 1,
        UnitId: 2,
        Quantity: 10.00,
        Rate: 100.00
      },
      {
        ItemId: 2,
        UnitId: 3,
        Quantity: 20.00,
        Rate: 200.00
      },
      {
        ItemId: 3,
        UnitId: 4,
        Quantity: 30.00,
        Rate: 300.00
      }
    ]
  };
  const {
    firstFieldRef,
    tempRows,
    isLoading,
    isTableLoading,
    handleDelete,
    handleDrawer,
    handleEdit,
    handleOpeningInventoryEdit,
    handleSearch,
    handleSubmit,
    handleOpeningInventorySubmit,
    handleAdd,
    handleSubmitAll,
    open,
    add,
    formData,
    search,
    dataSet,
    transformOptions,
    inputRef,
  } = useFormHook("GRN", initialValues);

  const { getColumnSearchProps, sort, sortString } = TableConfig();
  const [filteredDepartments, setFilteredDepartments] = useState(transformOptions(dataSet?.Table2));
  const [formValues, setFormValues] = useState({});
  const [editFormValues, setEditFormValues] = useState({})
  const formRef = useRef(null);
  const [data, setData] = useState(dataSet?.Table6 || []);
  const [changedRecords, setChangedRecords] = useState([]);
  const [isFormValuesChange, setIsFormValuesChange] = useState(false)
  const [isDisabled, setIsDisabled] = useState(false)
  const OperationId = recordId > 0 ? 3 : 2;


  useEffect(() => {
    if (dataSet?.Table6) {
      setData(dataSet.Table6);
    }
  }, [dataSet?.Table6]);

  useEffect(() => {
    if (dataSet?.Table6) {
      // Filter the records where both Quantity and Rate are greater than 0
      const filteredRecords = dataSet.Table6.filter(record => 
        record.Quantity > 0 || record.Rate > 0
      );

      // Update the state with the filtered records
      setChangedRecords(filteredRecords);
    }
  }, [dataSet]);
  
  
  const handleInputChange = (value, record, field) => {
    // Update the changedRecords state
    setChangedRecords(prevRecords => {
      const existingIndex = prevRecords.findIndex(r => r.ItemId === record.ItemId);

      if (existingIndex !== -1) {
        // Record exists, update it
        const updatedRecords = [...prevRecords];
        updatedRecords[existingIndex] = { ...updatedRecords[existingIndex], [field]: value };
        return updatedRecords;
      } else {
        // Record does not exist, add new one
        return [...prevRecords, { ...record, [field]: value }];
      }
    });
    // Update the data array
    const updatedData = data.map(item =>
      item.ItemId === record.ItemId
        ? { ...item, [field]: value }  // Update the matching item
        : item  // Leave other items unchanged
    );
    setData(updatedData)
  };


  const TransactionDetail = getTransactionDetail(changedRecords);

  const columns = [
    {
      key: "1",
      title: "Branch",
      dataIndex: "BranchName",
    },
    {
      key: "2",
      title: "Department",
      dataIndex: "DepartmentName",
    },
    {
      key: "3",
      title: "Opening Date",
      dataIndex: "TransactionDate",
    },
    {
      key: "4",
      title: "Is Submit",
      dataIndex: "IsSubmit",
      render: (text) => (text ? "true" : "false"),
    },
    {
      key: "5",
      title: "Action",
      // className: "text-center",
      render: (_, record) => (
        <Space>
          {" "}
          <ButtonComponent
            icon={<EditOutlined />}
            onClick={() => {
              setIsDisabled(record?.IsSubmit)
              setRecordId(record?.Id)
              handleOpeningInventoryEdit(record)
              const {BranchId, DepartmentId, Id, TransactionDate} = record || {};
              setEditFormValues({BranchId, DepartmentId, Id, TransactionDate}) 
              handleDrawer(Operations.Update)
            }}
          />{" "}
          <PopDelete handleDelete={() => handleDelete(record)}>
            <ButtonComponent disabled={record.IsSubmit} icon={<DeleteOutlined />} danger={true} />{" "}
          </PopDelete>
        </Space>
      ),
    },
  ];



  const columns2 = [
    {
      key: "1",
      title: "Category",
      dataIndex: "CategoryName",
      ...getColumnSearchProps("CategoryName"),

    },
    {
      key: "2",
      title: "Sub Category",
      dataIndex: "SubCategoryName",
      ...getColumnSearchProps("SubCategoryName"),
    },
    {
      key: "3",
      title: "Item",
      dataIndex: "ItemName",
      ...getColumnSearchProps("ItemName"),
    },
    {
      key: "4",
      title: "Item Code",
      dataIndex: "ItemCode",
      ...getColumnSearchProps("ItemCode"),
    },
    {
      key: "3",
      title: "Issuance Unit",
      dataIndex: "IssuanceUnit",
      ...getColumnSearchProps("IssuanceUnit"),
    },
    {
      key: "3",
      title: "Purchase Unit",
      dataIndex: "PurchaseUnit",
      ...getColumnSearchProps("PurchaseUnit"),
    },
    {
      key: "3",
      title: "Recipe Unit",
      dataIndex: "RecipeUnit",
      ...getColumnSearchProps("RecipeUnit"),
    },
    {
      key: "4",
      title: "Quantity",
      dataIndex: "Quantity",
      render: (_, record) => (
        <InputText
          type='number'
          disabled={isDisabled}
          value={record.Quantity}
          onChange={(value) => handleInputChange(value, record, 'Quantity')}
        />
      ),
      ...getColumnSearchProps("Quantity"),
    },
    {
      key: "5",
      title: "Rate",
      dataIndex: "Rate",
      render: (_, record) => (
        <InputText
          type='number'
          disabled={isDisabled}
          value={record.Rate}
          onChange={(value) => handleInputChange(value, record, 'Rate')}
        />
      ),
      ...getColumnSearchProps("Rate"),
    },
    // {
    //   key: "6",
    //   title: "Action",
    //   render: (_, record) => (
    //     <Space>
    //       {" "}
    //       <PopDelete handleDelete={() => handleDelete(record)}>
    //         <ButtonComponent icon={<MinusCircleOutlined />} danger={true} type={'dashed'}  />{" "}
    //       </PopDelete>
    //     </Space>
    //   ),
    // }
  ];

  const searchFields = (
    <>
      <Row gutter={[20, 0]}>
        <Col xs={24} md={12} xl={8}>
          <InputSelect label={"Branch"} name={"BranchId"} options={transformOptions(dataSet?.Table2)} />
        </Col>
        <Col xs={24} md={12} xl={8}>
          <InputSelect label={"Department Name"} name={"DepartmentId"} options={transformOptions(dataSet?.Table3)} />
        </Col>
        <Col xs={24} md={12} xl={8}>
          <InputDate label={"Opening Date"} name={"TransactionDate"} />
        </Col>
      </Row>
    </>
  );

  const formFields = (
    <Row gutter={[20, 0]}>
      <Col xs={24} md={12} xl={8}>
        <InputSelect
          disabled={isDisabled}
          label={"Branch"}
          name={"BranchName"}
          options={transformOptions(dataSet?.Table2)}
          onChange={value => {
            if (value) {
              // Filter departments based on selected branch
              const departments = getDepartmentAccordingBranch(dataSet?.Table3, value)
              setFilteredDepartments(transformOptions(departments));
            } else {
              setFilteredDepartments(transformOptions(dataSet?.Table2));
            }
          }
          }
          myRef={inputRef}
        />
      </Col>
      <Col xs={24} md={12} xl={8}>
        <InputSelect
          label={"Department Name"}
          disabled={isDisabled}
          name={"DepartmentName"}
          options={filteredDepartments || transformOptions(dataSet?.Table3)}
        />
      </Col>
      <Col xs={24} md={12} xl={8}>
        <InputDate
          label={"Opening Date"}
          name={"TransactionDate"}
          disabled={isDisabled}
        />
      </Col>
    </Row>
  );


  return (
    // <Card>
    // <BasicCrud
    //   formTitle="Opening Inventory"
    //   tableTitle="Opening Inventory"
    //   searchFields={searchFields}
    //   formFields={formFields}
    //   handleSubmit={handleSubmit}
    //   handleSearch={handleSearch}
    //   addFormInstance={addFormInstance}
    //   searchFormInstance={searchFormInstance}
    //   extra={'add'}
    //   rows={rows}
    //   columns={columns}
    //   handleDrawer={handleDrawer}
    //   isDrawerOpen={isDrawerOpen}
    //   isFormLoading={isFormLoading}
    //   isTableLoading={isTableLoading}
    // />
    <>
      <FormComponent
        title={"Search Opening Inventory"}
        children={searchFields}
        handleSubmit={handleSearch}
        form={search}
        submit={"Search"}
        isLoading={isLoading}
        initialValues={initialValues}
        // hideActions={true}
        // extra={
        //   <ButtonComponent
        //     icon={<EditOutlined />}
        //     text={"Add"}
        //     size={"small"}
        //     onClick={() => handleDrawer(Operations.Insert)}
        //   />
        // }
      />

      <br />
      <TableComponent
        columns={columns || []}
        rows={dataSet?.Table1 || []}
        title={"Opening Inventory List"}
        loading={isTableLoading}
      />

      <DrawerComponent
        onClose={() => {
          // setInventoryEditData([])
          handleDrawer(Operations.Select)
          setFormValues({})
          setEditFormValues({})
          setRecordId(null)
          setIsFormValuesChange(false)
          setIsDisabled(false)
        }}
        open={open}
        width={1000}
        extra={
          <Space>
            <ButtonComponent
              icon={<EditOutlined />}
              text={"Save"}
              disabled={isDisabled}
              size={"small"}
              onClick={() => {
                handleDrawer(Operations.Update)
                if(!isFormValuesChange){
                  handleOpeningInventorySubmit({
                    DepartmentId: editFormValues.DepartmentId, BranchId: null ,TransactionDate: editFormValues.TransactionDate
                    , TransactionDetail, Id:recordId, OperationId,IsSubmit: false
                  });
                }else {
                  handleOpeningInventorySubmit({
                    DepartmentId: formValues.DepartmentName, TransactionDate: formValues.TransactionDate
                    , TransactionDetail, Id:recordId,OperationId,IsSubmit: false
                  });
                }
                setChangedRecords([])
              }}
            />
            <ButtonComponent
              icon={<SaveOutlined />}
              text={"Submit"}
              size={"small"}
              disabled={isDisabled}
              onClick={() => {
                handleDrawer(Operations.Update)
                if(!isFormValuesChange){
                  handleOpeningInventorySubmit({
                    DepartmentId: editFormValues.DepartmentId, BranchId: null ,TransactionDate: editFormValues.TransactionDate
                    , TransactionDetail, Id:recordId, OperationId,IsSubmit: true
                  });
                }else {
                  handleOpeningInventorySubmit({
                    DepartmentId: formValues.DepartmentName, TransactionDate: formValues.TransactionDate
                    , TransactionDetail, Id:recordId,OperationId,IsSubmit: true
                  });
                }
                setChangedRecords([])
              }
              }
            />
          </Space>
        }
      >
        <InventoryForm
          children={formFields}
          disabled={isDisabled}
          handleSubmit={() => { }}
          form={add}
          submit={formData?.OperationId == Operations.Update ? "Update" : "Add"}
          isLoading={isLoading}
          initialValues={initialValues}
          getFormValues={setFormValues}
          setIsFormValuesChange={setIsFormValuesChange}
          ref={formRef}
        />

        <TableComponent
          columns={columns2 || []}
          rows={data || []}
          title={"Opening Inventory List ..."}
          header={true}
        />

      </DrawerComponent>
    </>
    // </Card>
  );
}
